import { createSignal } from "solid-js";
export const [paused, setPaused] = createSignal(false);
